import { useReducer, useState, useEffect } from 'react'
import moment from 'moment'
import axios from 'axios'

export const getInitialFiltersState = isAllOriginalGranted => {
    return {
        from: moment().subtract(14, 'days').unix(),
        to: null,
        statuses: [],
        operation_modes: [],
        is_assigned: !isAllOriginalGranted,
        device_types: [],
        sort_by: ''
    }
}

const filterReducer = (state, action) => {
    switch (action.type) {
        case 'is_assigned': {
            return {
                ...state,
                is_assigned: action.value
            }
        }
        case 'from':
            return {
                ...state,
                from: action.date
            }
        case 'to':
            return {
                ...state,
                to: action.date
            }
        case 'status': {
            return {
                ...state,
                statuses: action.value
            }
        }
        case 'operationMode': {
            return {
                ...state,
                ...action.value
            }
        }
        case 'sort': {
            return {
                ...state,
                sort_by: action.sort_by
            }
        }
        default:
            return state
    }
}

export const useReportsFilters = (
    initialFilters,
    withAssignedToggle,
    deviceId,
    locationId
) => {
    const initFilters = {
        ...getInitialFiltersState(withAssignedToggle),
        ...initialFilters
    }
    if (!withAssignedToggle) initFilters.is_assigned = true
    const [filters, d] = useReducer(filterReducer, initFilters)
    const [isLoadingFilters, setIsLoadingFilters] = useState(true)

    const getRangeReport = async () => {
        const params = {}
        if (deviceId) params.deviceId = deviceId
        if (locationId) params.locationId = locationId

        try {
            const report = (
                await axios.get(`${process.env.API_URL}/reports/last-report`, {
                    params
                })
            ).data
            if (report)
                d({ type: 'from', date: moment(report.created_at).unix() })
            setIsLoadingFilters(false)
        } catch (ex) {
            setIsLoadingFilters(false)
        }
    }

    useEffect(() => {
        getRangeReport()
        // locationId argument is important for the locations view when navigating
        // from one location to another when reports tab is open
    }, [locationId])

    return {
        filters,
        d,
        isLoadingFilters
    }
}
